'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { IdeaIcon } from '@/components/ui/icon/glyphs';
interface SuggestedOutcomesEmptyStateProps {
  onSuggest: () => void;
  canSuggest: boolean;
  isCreator?: boolean;
}
export function SuggestedOutcomesEmptyState(t0) {
  const $ = _c(16);
  const {
    onSuggest,
    canSuggest,
    isCreator: t1
  } = t0;
  const isCreator = t1 === undefined ? false : t1;
  const t = useTranslations("launchpad.suggestedOutcomes");
  let t2;
  if ($[0] !== isCreator || $[1] !== t) {
    t2 = isCreator ? t("addOutcome") : t("breakTheIce");
    $[0] = isCreator;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const ctaLabel = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("emptyTitle");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("emptyBody");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== canSuggest || $[8] !== ctaLabel || $[9] !== isCreator || $[10] !== onSuggest) {
    t5 = canSuggest || isCreator ? <AnimatedButton variant="primary" size="sm" onClick={onSuggest}>{ctaLabel}</AnimatedButton> : undefined;
    $[7] = canSuggest;
    $[8] = ctaLabel;
    $[9] = isCreator;
    $[10] = onSuggest;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <EmptyState size="compact" icon={IdeaIcon} title={t3} description={t4} action={t5} />;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}